import './styles/index.scss';
import {indexBlocks} from './blocks/index-blocks';
import {activePage} from "./scripts/active-page";
import {generalPageAnimation} from './scripts/generalPageAnimation';
import {heroIntro} from './scripts/heroIntro';
import {lineReveal} from './scripts/lineReveal';
import {enableLiveStyleReload} from './scripts/live-style-reload';
import {progressiveImages} from './scripts/progressive-image';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.fbsThemeVendors = window.fbsThemeVendors || {};
window.fbsThemeVendors.gsap = gsap;
window.fbsThemeVendors.ScrollTrigger = ScrollTrigger;

enableLiveStyleReload();

document.addEventListener('DOMContentLoaded', async () => {
  indexBlocks();
  activePage();
  heroIntro();
  generalPageAnimation();
  lineReveal();
  progressiveImages();
});

let loaded = false;

async function onLoad() {
  gsap.config({
    nullTargetWarn: false,
  });
  if (document.readyState === 'interactive' && !loaded) {
    loaded = true;
    gsap.registerPlugin(ScrollTrigger);
    
    
    document.body.classList.add('loaded');
    //region force page to scroll to element if url has hash
    // Skipped entirely on pages with the home-hero intro: that overlay
    // deliberately forces the page to the top so the intro is always seen
    // (heroIntro.js) — this hash-scroll used to run 600ms later and
    // silently scroll back down to the hash target, undoing that.
    const hash = window.location.hash;
    const hasHeroIntro = !!document.querySelector('[data-component="home-hero"]');
    if (hash && !hasHeroIntro) {
      const block = document.querySelector(hash);
      if (block) {
        document.body.classList.remove('loaded');
        setTimeout(() => {
          // If ScrollTrigger is available, refresh it to account for any layout-shifting animations
          if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.refresh) {
            ScrollTrigger.refresh();
          }
          
          const header = document.querySelector('header');
          const headerHeight = header ? header.offsetHeight : 93;
          const targetTop = block.getBoundingClientRect().top + window.scrollY - headerHeight;
          
          window.scrollTo({
            top: targetTop,
            behavior: 'auto' // Use auto here because we want an immediate jump after the delay, but we could use smooth if preferred.
          });
          
          document.body.classList.add('loaded');
        }, 600); // 600ms allows most initial hero animations to progress
      }
    }
    //endregion force page to scroll to element if url has hash
  }
}

onLoad();

document.onreadystatechange = function () {
  onLoad();
};


